import React from 'react';
import * as Inovx from '@shared';
import AssetBreadcrumbPanel from './AssetBreadcrumbPanel';
import { IHierarchyItemDetail } from '../Interfaces/ViewerInterfaces';

interface NavigationPopupProps extends React.PropsWithChildren<{}> {
    //kv: IKnowledgeViewDetail;
    selectedAsset: IHierarchyItemDetail;
    toolbar: React.ReactNode;
    onAssetClick: (asset: IIdentityItem) => void;
}

const NavigationPopup = (props: NavigationPopupProps) => {
    var breadcrumbList: INamedItem[] = [... props.selectedAsset.Parents]; // slice() does a clone of the original array!
    breadcrumbList.push({ ID: props.selectedAsset.ID, Name: props.selectedAsset.Name });

    return (
        <div className="no-print navigation-popup-container is-visible">
            {/* <Inovx.Shared.Controls.ActionInProgressLoader actionKey={[AssetConstants.KV_RECEIVE_SELECTED_ASSET, AssetConstants.KV_RECEIVE_ATTACHED_MP]} class={'temp-modal-loader'}>
                <div className="action-in-progress-loader-vsm"></div>
            </Inovx.Shared.Controls.ActionInProgressLoader> */}

            <div className="popup-content">
                <AssetBreadcrumbPanel
                    breadcrumbList={breadcrumbList}
                    // assetObjectListID={props.kv.AssetObjectListID}
                    // projectID={props.kv.ProjectID}
                    showLastItem={true}
                    showLastItemChildren={true}
                    //isMarkedPoint={props.selectedAsset.IsMarkedPoint}
                    onBreadcrumbClick={(e, crumb) => props.onAssetClick(crumb)}
                    onBreadcrumbChildClick={(e, parentAsset, childAsset) => props.onAssetClick(childAsset)}
                />
                {props.toolbar}
            </div>
        </div>
    );
}

export default NavigationPopup;